import axios from 'axios'

import { ERROR_MESSAGE_SAVING } from '../constants'
import { dividendsAndInterestSelector } from '../selectors'
import { handleRequestError } from './request'
import { updateAndSaveActiveTaxReturn } from './tax-return'

export const REQUEST_DIVIDENDS_AND_INTEREST_SUMMARY = 'REQUEST_DIVIDENDS_AND_INTEREST_SUMMARY'
export const RECEIVE_DIVIDENDS_AND_INTEREST_SUMMARY = 'RECEIVE_DIVIDENDS_AND_INTEREST_SUMMARY'
export const SAVE_DIVIDENDS_AND_INTEREST_SUMMARY = 'SAVE_DIVIDENDS_AND_INTEREST_SUMMARY'
const CREATE_DIVIDENDS_AND_INTEREST_SUMMARY = 'CREATE_DIVIDENDS_AND_INTEREST_SUMMARY'

export const requestDividendsAndInterestSummary = (taxReturnId) => (dispatch) => {
    dispatch({ type: REQUEST_DIVIDENDS_AND_INTEREST_SUMMARY, data: { taxReturnId } })

    axios
        .get(`/dividendsandinterestsummaries/${taxReturnId}`)
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(
                receiveDividendsAndInterestSummary({
                    fetchSuccessful: true,
                    ...responseData,
                })
            )
        })
        .catch((error) => {
            if (error?.status === 404) {
                dispatch(receiveDividendsAndInterestSummary({ fetchSuccessful: true }))
                return
            }

            dispatch(receiveDividendsAndInterestSummary({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}

export const receiveDividendsAndInterestSummary = (data) => ({ type: RECEIVE_DIVIDENDS_AND_INTEREST_SUMMARY, data })

export const saveDividendsAndInterestSummary = (data) => (dispatch) => {
    dispatch({ type: SAVE_DIVIDENDS_AND_INTEREST_SUMMARY, data })

    const { taxReturnId } = data

    return axios
        .put(`/dividendsandinterestsummaries/${taxReturnId}`, data)
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(receiveDividendsAndInterestSummary(responseData))
            return responseData
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
            return Promise.reject(error)
        })
}

export const updateAndSaveDividendsAndInterestSummary = (data) => (dispatch, getState) => {
    const { dividendsAndInterestSummary } = dividendsAndInterestSelector(getState())
    const updatedDividendsAndInterestSummary = { ...dividendsAndInterestSummary, ...data }

    dispatch(receiveDividendsAndInterestSummary(updatedDividendsAndInterestSummary))
    return dispatch(saveDividendsAndInterestSummary(updatedDividendsAndInterestSummary)).catch(() => {})
}

export const updateAndSaveDividendsAndInterestSummaryStatus =
    ({ status }) =>
    (dispatch, getState) => {
        const { dividendsAndInterestSummary } = dividendsAndInterestSelector(getState())
        const updatedDividendsAndInterestSummary = { ...dividendsAndInterestSummary, status }

        dispatch(receiveDividendsAndInterestSummary(updatedDividendsAndInterestSummary))
        return dispatch(saveDividendsAndInterestSummary(updatedDividendsAndInterestSummary))
            .then(() => dispatch(updateAndSaveActiveTaxReturn({ dividendsAndInterestSummaryStatus: status })))
            .catch(() => {})
    }

export const createDividendsAndInterestSummary =
    (data = {}) =>
    (dispatch, getState) => {
        const { id } = getState().taxReturn

        dispatch({ type: CREATE_DIVIDENDS_AND_INTEREST_SUMMARY })

        return axios
            .put(`/dividendsandinterestsummaries/${id}`, data)
            .then((response) => {
                const responseData = response?.data || {}
                dispatch(receiveDividendsAndInterestSummary(responseData))
            })
            .catch((error) => {
                dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
                return Promise.reject(error)
            })
    }

export const createOrUpdateDividendsAndInterestSummary = (data) => (dispatch, getState) => {
    const { dividendsAndInterestSummary, hasDividendsAndInterestSummary } = dividendsAndInterestSelector(getState())

    const persist = hasDividendsAndInterestSummary
        ? updateAndSaveDividendsAndInterestSummary
        : createDividendsAndInterestSummary
    return dispatch(persist({ ...dividendsAndInterestSummary, ...data }))
}
